exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".couple-row[data-v-5244671e] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.couple-row > *[data-v-5244671e]:nth-child(1) {\n  flex: 0.2;\n  display: flex;\n  align-items: flex-end;\n  margin-right: 16px;\n}\n.couple-row > *[data-v-5244671e]:nth-child(2) {\n  flex: 0.8;\n}", ""]);

// exports
